// extracted by mini-css-extract-plugin
export var Cursor = "G_b6";
export var Hidden = "G_b5";
export var Hovering = "G_b7";
export var NoCursor = "G_b4";